import * as React from 'react';
import SignInButton from '../atoms/SignInButton';
import i18n from '../R/string/i18n';
import styled from 'styled-components';
import Image from '../atoms/Image';
import space from '../utils/style/space';
import assets from '../R/assets';

const SignInButtonStyled = styled(SignInButton)`
  margin-bottom: ${space.xxs}px;
`;

const Span = styled.span`
  margin-left: ${space.xxs}px;
`;

type Props = {
  onClick: () => void;
  isSignUp: boolean;
};

const FacebookButton = ({ onClick, isSignUp }: Props) => {
  return (
    <SignInButtonStyled onClick={onClick} type="button">
      <Image src={assets.facebookIcon} alt="facebook Button" />
      <Span>
        {isSignUp
          ? i18n.socialLoginSignUpWithFacebook()
          : i18n.socialLoginSignInWithFadebook()}
      </Span>
    </SignInButtonStyled>
  );
};

export default FacebookButton;
